// extracted by mini-css-extract-plugin
export default {"sider":"Sider_sider__TKPXs","siderHeader":"Sider_siderHeader__HERH+"};